import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { WalletAddress } from '@root/entities/wallet'
import { Input, WalletIcon } from '@root/shared/ui-kit'

type Props = {
  value: string
  onChange: (address: WalletAddress) => void
  onWalletClick: () => void
  withQrCode?: boolean
}

export const TransferCardAddressInput: React.FC<Props> = ({
  onChange,
  onWalletClick,
  value,
}) => {
  const { t } = useTranslation()
  return (
    <Root>
      <Input
        placeholder={t('wallet.address_input_placeholder')}
        value={value}
        onChange={(e) => onChange(WalletAddress(e.target.value))}
        endContent={
          <EndContent type="button" onClick={() => onWalletClick()}>
            <WalletIcon size={18} />
          </EndContent>
        }
      />
    </Root>
  )
}

const Root = styled.div``

const EndContent = styled.button`
  all: unset;
  cursor: pointer;
  display: grid;
  align-items: center;
  height: 100%;
  transition: all 0.3s ease;
  color: var(--textA-10);

  &:hover {
    color: var(--text-11);
  }
`
